import { connect } from 'react-redux';
import {
  addBidDetail,
  editMember
 } from '../modules/tour';
import { requestHotelSearch, requestHotelAdvanceSearch } from '../../hotels/modules/hotels';

import AddBookingModal from './AddBookingModal';

const mapDispatchToProps = {
  addBidDetail,
  editMember,
  requestHotelSearch,
  requestHotelAdvanceSearch
};

const mapStateToProps = state => ({
  //tour: state.tours.selectedTour.tour,
});
const AddBookingModalContainer = connect(
    mapStateToProps,
    mapDispatchToProps)(AddBookingModal);
export default AddBookingModalContainer;



// WEBPACK FOOTER //
// src/routes/tours/components/AddBookingModalContainer.js